export enum MODAL_STATE {
  NEW_COMPANY_FIRST_STEP = 'NEW_COMPANY_FIRST_STEP',
  EDIT_COMPANY_FIRST_STEP = 'EDIT_COMPANY_FIRST_STEP',
  BANK_ACCOUNT_NAME_EDIT = 'BANK_ACCOUNT_NAME_EDIT',
  BANK_ACCOUNT_DELETE = 'BANK_ACCOUNT_DELETE',
  API_CONNECT = ' API_CONNECT',
  SZAMLAZZHU = 'SZAMLAZZHU',
  AGGREG8 = 'AGGREG8',
  API_CONNECT_REVOKE = 'API_CONNECT_REVOKE',
  FILE_DELETE = 'FILE_DELETE',
  NEW_ACCESS_TOKEN = 'NEW_ACCESS_TOKEN',
  REVEAL_SECRET = 'REVEAL_SECRET',
  REVOKE_TOKEN = 'REVOKE_TOKEN',
  ACCOUNTANT_DELETE = 'ACCOUNTANT_DELETE',
  NEW_ACCOUNTANT = 'NEW_ACCOUNTANT',
  MOVE_TO_ANOTHER_COMPANY = 'MOVE_TO_ANOTHER_COMP',
}

export enum TOASTER_STATE {
  ENTREPRENEUR_CREATION_SUCCESS = 'ENTREPRENEUR_CREATION_SUCCESS',
  ENTREPRENEUR_CREATION_FAILED = 'ENTREPRENEUR_CREATION_FAILED',
  ACCOUNTANT_AUTH_SUCCESS = 'ACCOUNTANT_AUTH_SUCCESS',
  ACCOUNTANT_AUTH_FAILED = 'ACCOUNTANT_AUTH_FAILED',
  ENTREPRENEUR_LIST_FETCH_FAILED = 'ENTREPRENEUR_LIST_FETCH_FAILED',
  ENTREPRENEUR_SAVE_OR_EDIT_FAILED = 'ENTREPRENEUR_SAVE_OR_EDIT_FAILED',
  ENTREPRENEUR_SAVE_OR_EDIT_SUCCESS = 'ENTREPRENEUR_SAVE_OR_EDIT_SUCCESS',
  ACCOUNTANT_CREATED_FAILED = 'ACCOUNTANT_CREATED_FAILED',
  DELETE_ACCOUNTANT_FAILED = 'DELETE_ACCOUNTANT_FAILED',
  DELETE_ACCOUNTANT_SUCCESS = 'DELETE_ACCOUNTANT_SUCCESS',
  COMPANY_CREATION_FAILED = 'COMPANY_CREATION_FAILED',
  EMPTY = 'EMPTY',
  UPLOADED_FILE_STATISTICS = 'UPLOADED_FILE_STATISTICS',
  FILE_UPLAOD_FAILED = 'FILE_UPLAOD_FAILED',
  FILE_UPLAOD_TIMEOUT = 'FILE_UPLAOD_TIMEOUT',
  AGGREG8_API_CONNECT_SUCCESS = 'AGGREG8_API_CONNECT_SUCCESS',
  AGGREG8_API_CONNECT_FAILED_OR_TIMEOUT = 'AGGREG8_API_CONNECT_FAILED_OR_TIMEOUT',
  AGGREG8_API_CONNECT_REVOKE_SUCCESS = ' AGGREG8_API_CONNECT_REVOKE_SUCCESS',
  AGGREG8_API_CONNECT_REVOKE_FAILED = ' AGGREG8_API_CONNECT_REVOKE_FAILED',
  AGGREG8_API_CONNECT_FAILED = 'AGGREG8_API_CONNECT_FAILED',
  AGGREG8_WAIT_FOR_RESPONSE = 'AGGREG8_WAIT_FOR_RESPONSE',
  EXPORT_FILES_FAILED = 'EXPORT_FILES_FAILED',
  EXPORT_FILES_EMPTY = 'EXPORT_FILES_EMPTY',
  EXPORT_FILES_DATE_WARNING = 'EXPORT_FILES_DATE_WARNING',
  RECAPTCHA_WARNING = 'RECAPTCHA_WARNING',
  EXPIRED_LINK = 'EXPIRED_LINK',
  ACCESS_TOKEN_REVOKED_SUCCESS = 'ACCESS_TOKEN_REVOKED_SUCCESS',
  ACCESS_TOKEN_REVOKED_FAILED = 'ACCESS_TOKEN_REVOKED_FAILED',
  ACCESS_TOKEN_CREATION_FAILED = 'ACCESS_TOKEN_CREATION_FAILED',
  GET_ACCOUNTANT_LIST_BY_COMPANY_FAILED = 'GET_ACCOUNTANT_LIST_BY_COMPANY_FAILED',
  ACCOUNT_SAVE_SUCCESS = 'ACCOUNT_SAVE_SUCCESS',
  ACCOUNT_SAVE_FAILED = 'ACCOUNT_SAVE_FAILED',
  BANK_CONFIG_SAVE_FAILED = 'BANK_CONFIG_SAVE_FAILED',
  BANK_CONFIG_SAVE_SUCCESS = 'BANK_CONFIG_SAVE_SUCCESS',
  PRIVACY_UPDATE_FAILED = 'PRIVACY_UPDATE_FAILED',
  PRIVACY_UPDATE_SUCCESS = 'PRIVACY_UPDATE_SUCCESS',
  MOVE_COMPANY_FAILED = 'MOVE_COMPANY_FAILED',
  DELETE_COMPANY_FAILED = 'DELETE_COMPANY_FAILED',
}

export enum CONNECTED_API_TYPE {
  SZAMLAZZHU = 'szamlazzhu',
  AGGREG8 = 'aggreg8',
  ADRIANA = 'adriana',
}

export enum USER_TYPE {
  ACCOUNTANT = 'accountant',
  ENTREPRENEUR = 'entrepreneur',
}

export let TIMEOUT = 180000;

export const changeTimeout = (timeout: number) => {
  TIMEOUT = timeout;
};

export enum EXPIRATION_STATUS {
  EXPIRED,
  EXPIRED_SOON,
  NOT_EXPIRED,
  NO_INFORMATION,
}
